import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class InvoiceService {
    // Get all 
    static async getAllInvoices(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.INVOICES; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        }
        else {
            console.error('Failed to fetch invoices.');
            return [];
        }
    }

    // Create 
    static async addNewInvoice(data) {
        responseModel = new ResponseModel();
        const requestURL =  `${EndPoint.INVOICES}/create`; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Invoice added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new invoice.');
        }
    }

    // Get by ID
    static async getInvoiceById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.INVOICES}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch invoice by ID');
        }
    }

    // Update
    static async updateInvoiceById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.INVOICES}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Invoice updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update invoice.');
        }
    }

    // Delete
    static async deleteInvoice(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.INVOICES}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete invoice.');
            }
        } catch (error) {
            console.error('Error deleting invoice:', error);
            throw error;
        }
    }

    // Delete many
    static async deleteManyInvoices(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.INVOICES}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
